var map = {
	"./two": 3,
	"./two.js": 3
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



/*****************
 ** WEBPACK FOOTER
 ** ./chunks/context nonrecursive two
 ** module id = 1
 ** module chunks = 1
 **/